import { Component } from '@headless-workspace/typings';
import { GlowFieldWrapper, GlowFieldWrapperProps, GlowPills, GlowPillsProps } from '../../atoms';

type GlowPillsWrapperProps = GlowPillsProps & Omit<GlowFieldWrapperProps, 'children'>;

export const GlowPillsWrapper: Component<GlowPillsWrapperProps> = ({
    fieldId,
    required,
    contents,
    pillClassName,
    pillWrapperClassName,
    defaultSelected,
    onChange,
    className,
}) => {
    return (
        <GlowFieldWrapper fieldId={fieldId} required={required}>
            {() => (
                <GlowPills
                    type={'radio'}
                    contents={contents}
                    defaultSelected={defaultSelected as string}
                    onChange={onChange as (selectedIds: string) => void}
                    className={className}
                    pillClassName={pillClassName}
                    pillWrapperClassName={pillWrapperClassName}
                />
            )}
        </GlowFieldWrapper>
    );
};
